import { useParams, Navigate } from "react-router-dom";
import { FaCheckCircle, FaUserFriends, FaSuitcase, FaCarSide } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import StarRating from "../components/common/StarRating";
import { taxis } from "../data/content";
import { BOOKING_URL } from "../data/config";

export default function TaxiSingle() {
  const { id } = useParams();
  const taxi = taxis.find((t) => t.id === id);
  if (!taxi) return <Navigate to="/taxis" replace />;

  return (
    <>
      <PageHeader
        title={taxi.title}
        crumbs={[{ label: "Taxis", to: "/taxis" }, { label: taxi.title }]}
      />
      <section className="section">
        <div className="container two-col">
          <img src={taxi.image} alt={taxi.title} style={{ height: 420 }} />
          <div>
            <h2 style={{ fontSize: 34, margin: "14px 0" }}>{taxi.title}</h2>
            <p className="sec-text" style={{ marginBottom: 22 }}>{taxi.desc}</p>
            <div className="taxi-meta" style={{ borderTop: "none", marginBottom: 22 }}>
              <span><FaUserFriends /> {taxi.seats} Passengers</span>
              <span><FaSuitcase /> {taxi.luggage} Bags</span>
              <span><FaCarSide /> {taxi.models.length} Models</span>
            </div>
            <ul className="check-list" style={{ marginBottom: 26 }}>
              {taxi.features.map((f, i) => (
                <li key={i}><FaCheckCircle /> {f}</li>
              ))}
            </ul>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Book This Vehicle</a>
          </div>
        </div>
      </section>

      <section className="section bg-dark2">
        <div className="container">
          <h2 style={{ fontSize: 28, marginBottom: 24 }}>Available Models</h2>
          <div className="tag-list">
            {taxi.models.map((m, i) => <span key={i}>{m}</span>)}
          </div>

          <h2 style={{ fontSize: 28, margin: "44px 0 24px" }}>Customer Reviews</h2>
          <div className="grid grid-2">
            {taxi.reviews.map((r, i) => (
              <div className="card" style={{ padding: 26 }} key={i}>
                <StarRating rating={5} />
                <p className="sec-text" style={{ margin: "14px 0" }}>"{r.text}"</p>
                <h4 style={{ color: "var(--yellow)" }}>{r.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
